__turbopack_context__.v({
  "blurredButtonLink": "TopVideoSection-module__tbShXW__blurredButtonLink",
  "buttonContainer": "TopVideoSection-module__tbShXW__buttonContainer",
  "container": "TopVideoSection-module__tbShXW__container",
  "content": "TopVideoSection-module__tbShXW__content",
  "subTitle": "TopVideoSection-module__tbShXW__subTitle",
  "title": "TopVideoSection-module__tbShXW__title",
});
